import Swiper from 'swiper';
import { Pagination } from 'swiper/modules';

export function initSingleEsperienzaBlocks(root = document) {
  const sliders = root.querySelectorAll('.js-esperienza-ispirazione-swiper');

  sliders.forEach((sliderEl) => {
    const slides = sliderEl.querySelectorAll('.swiper-slide');

    if (slides.length <= 1) {
      const paginationEl = sliderEl.querySelector('.swiper-pagination');
      if (paginationEl) {
        paginationEl.style.display = 'none';
      }
      return;
    }

    new Swiper(sliderEl, {
      modules: [Pagination],
      slidesPerView: 'auto',
      spaceBetween: 8,
      centeredSlides: false,
      grabCursor: true,
      pagination: {
        el: sliderEl.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

//card Prenota ora on mobile
addEventListener('DOMContentLoaded', function () {
  var card = document.querySelector('.esperienza-booking-card-mobile');
  var sentinel = document.querySelector('.single-esperienza .js-esperienza-booking-sentinel');
  if (!card || !sentinel || !('IntersectionObserver' in window)) return;

  var SPACER = 16; // = $spacer-3 in px

  var io = new IntersectionObserver(function (entries) {
    var top = entries[0].boundingClientRect.top;
    card.classList.toggle('is-docked', top <= window.innerHeight - SPACER);
  }, { threshold: 0, rootMargin: '0px 0px -' + SPACER + 'px 0px' });

  io.observe(sentinel);
});

